<template lang="pug">
    .chat-login-failed-page Something went wrong, please refresh the page.
</template>

<script>
export default {
    name: 'chat-login-failed-page',
}
</script>
